import { render } from "./BirthdayView.vue?vue&type=template&id=370a57ee"
import script from "./BirthdayView.vue?vue&type=script&lang=js"
export * from "./BirthdayView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__